import { batch } from "solid-js";
import FeatureStore from "@rock-solid/feature-store";

import Admin, { AdminCanada } from "@repo/kikoff-models/Admin";
import canadaAdminRpc from "@repo/protobuf/api/canadaAdminRpc";
import UFunction from "@repo/utils/UFunction";

const initialState = {
  authenticated: null as boolean | null,
  admin: null as Admin | null,
};

export const { useAdmin } = FeatureStore.init("Admin", initialState).setup(
  ([store, setStore], { wrap }) => {
    const accessors = wrap
      .accessors({
        authenticated: () => store.authenticated,
      })
      .finalize();

    const actions = wrap
      .actions({
        googleSsoCallback(credential: string) {
          return canadaAdminRpc.Auth.googleSsoCallback({ credential }).then(
            ({ admin }) => {
              batch(() => {
                setStore("admin", AdminCanada.normalize(admin!));
                setStore("authenticated", true);
              });
            }
          );
        },
        fetch() {
          return canadaAdminRpc.Auth.showCurrentAdmin({})
            .then(({ admin }) => {
              batch(() => {
                setStore("admin", AdminCanada.normalize(admin!));
                setStore("authenticated", true);
              });
            })
            .catch((e) => {
              setStore("authenticated", false);

              // TODO: UNAUTHENTICATED error code
              if (e.issues?.[0]?.code !== "UNKNOWN") throw e;
            });
        },
        logout: UFunction.todo,
      })
      .finalize();

    return { accessors, actions };
  }
);
